<template>
    <div
        class="generalGroup-panel"
        @mouseleave.stop="close"
        @mouseenter="enterPanel=true"
        :class="{'mask-position': propMaskPosition}"
    >
        <div class="generalGroup-panel-body">
            <ul>
                <li
                    class="item"
                    @click.stop="generalHandle('refresh')"
                    @touchend="generalHandle('refresh')"
                    @touchmove.stop
                    @mousedown.stop
                    v-if="showToolBtn('refresh')"
                >
                    <refreshImg class="refresh" :color="'#007AFF'" />刷新
                </li>
                <li
                    class="item"
                    @click.stop="generalHandle('import')"
                    @touchend="generalHandle('import')"
                    @touchmove.stop
                    @mousedown.stop
                    v-if="showToolBtn('import')"
                >
                    <importImg class="import" :color="'#29CF68'" />导入
                </li>
                <li
                    class="item"
                    @click.stop="generalHandle('export')"
                    @touchend="generalHandle('export')"
                    @touchmove.stop
                    @mousedown.stop
                    v-if="showToolBtn('export')"
                >
                    <exportImg class="export" :color="'#007AFF'" />导出
                </li>
                <li
                    class="item"
                    @click.stop="generalHandle('search')"
                    @touchend="generalHandle('search')"
                    @touchmove.stop
                    @mousedown.stop
                    v-if="propFilter"
                >
                    <searchImg class="search" :color="'#29CF68'" />
                    {{searchText}}
                </li>
                <li
                    class="item"
                    @click.stop="generalHandle('clear')"
                    @touchend="generalHandle('clear')"
                    @touchmove.stop
                    @mousedown.stop
                    v-if="propFilter"
                >
                    <clearImg class="clear" :color="'#F9762B'" />清空查询条件
                </li>
                <li
                    class="item"
                    @click.stop="generalHandle('config')"
                    @touchend="generalHandle('config')"
                    @touchmove.stop
                    @mousedown.stop
                    v-if="showToolBtn('config')"
                >
                    <configImg :color="'#007AFF'" />表格列配置
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Gikam from "../../../core/gikam-core";
export default {
    props: {
        generalButtonGroup: [Array, Boolean],
        propFilterOpen: Boolean,
        propFilter: Boolean,
        propMaskPosition: Boolean,
        propEnterButton: Boolean
    },

    data() {
        return {
            enterPanel: false
        };
    },

    computed: {
        searchText() {
            return !this.propFilterOpen ? "开启快捷查询" : "关闭快捷查询";
        },

        enterButton() {
            return this.propEnterButton;
        }
    },

    mounted() {
        setTimeout(() => {
            if (
                !this.enterButton &&
                !this.enterPanel &&
                Gikam.generalGroupPanel
            ) {
                Gikam.generalGroupPanel.destroy();
            }
        }, 600);
    },

    methods: {
        generalHandle(name) {
            this.$emit("generalButtonClick", name);
        },

        showToolBtn(name) {
            if (this.generalButtonGroup === false) {
                return false;
            } else {
                return this.generalButtonGroup.indexOf(name) > -1;
            }
        },

        close() {
            this.enterPanel = false;
            Gikam.generalGroupPanel && Gikam.generalGroupPanel.destroy();
        }
    }
};
</script>

<style scoped>
@keyframes slide-in {
    from {
        transform: translate3d(0, 20px, 0);
        opacity: 0.3;
    }
    to {
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }
}

.generalGroup-panel {
    width: 120px;
    position: absolute;
    animation: slide-in 0.3s;
    padding-top: 27px;
    z-index: 10;
}

.generalGroup-panel.mask-position {
    padding-bottom: 27px;
    padding-top: 0;
}

.generalGroup-panel > .generalGroup-panel-body {
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
    background-color: #fff;
    border-radius: 4px;
}

.generalGroup-panel ul {
    margin: 0;
    padding: 4px 0;
}

.generalGroup-panel ul > li {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    height: 25px;
    padding: 0 8px;
    cursor: pointer;
}

.generalGroup-panel ul > li:hover {
    background-color: rgba(0, 122, 255, 0.08);
}

.generalGroup-panel svg {
    width: 14px;
    margin-right: 6px;
}

.generalGroup-panel svg.refresh {
    width: 16px;
    margin-left: -2px;
}

.generalGroup-panel svg.export {
    width: 16px;
    margin-left: -2px;
}

.generalGroup-panel svg.search {
    width: 16px;
    margin-left: -2px;
}

.generalGroup-panel svg.clear {
    width: 12px;
    margin-right: 7px;
}
</style>